"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { ImageSlot } from "./image-slot";
export function CtaSection() {
  const $ = _c(34);
  const {
    t
  } = useTranslation();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="pointer-events-none absolute inset-0"><div className="absolute top-0 right-0 h-80 w-100 translate-x-1/4 -translate-y-1/4 rounded-full bg-teal-500/10 blur-[80px]" /><div className="absolute bottom-0 left-0 h-60 w-75 -translate-x-1/4 translate-y-1/4 rounded-full bg-cyan-500/10 blur-[60px]" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("landing.cta.title1");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <br />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("landing.cta.title2");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <span className="text-teal-400">{t3}</span>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t1 || $[9] !== t4) {
    t5 = <h2 className="text-2xl font-bold tracking-tight text-white sm:text-4xl">{t1}{t2}{t4}</h2>;
    $[8] = t1;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t) {
    t6 = t("landing.cta.subtitle");
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t6) {
    t7 = <p className="mt-4 max-w-md text-base text-slate-400">{t6}</p>;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t) {
    t8 = t("landing.cta.login");
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <ArrowRight className="size-4 transition-transform group-hover:translate-x-0.5" />;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t8) {
    t10 = <Link href="/auth/login" className="group flex items-center gap-2 rounded-xl bg-white px-6 py-3 text-sm font-semibold text-slate-900 shadow-lg transition-all hover:bg-slate-50">{t8}{t9}</Link>;
    $[18] = t8;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t) {
    t11 = t("landing.cta.register");
    $[20] = t;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11) {
    t12 = <Link href="/auth/register" className="flex items-center gap-2 rounded-xl border border-white/20 px-6 py-3 text-sm font-medium text-white transition-all hover:border-white/30 hover:bg-white/5">{t11}</Link>;
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t10 || $[25] !== t12) {
    t13 = <div className="mt-8 flex flex-wrap items-center gap-3">{t10}{t12}</div>;
    $[24] = t10;
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t13 || $[28] !== t5 || $[29] !== t7) {
    t14 = <div>{t5}{t7}{t13}</div>;
    $[27] = t13;
    $[28] = t5;
    $[29] = t7;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <div className="hidden justify-center lg:flex"><ImageSlot id="cta-illustration" className="h-56 w-full max-w-sm sm:h-64" src="/images/cta.webp" prompt="3D rendered illustration: a glossy 3D tablet floating at a slight angle, screen glowing with a simplified pharmacy dashboard and a prominent 'Best Price' teal badge. Around it float small 3D icons: pill capsule, price tag with down arrow, checkmark shield, bar chart. Teal/cyan volumetric glow on elements. Dark slate background (to match a dark section). Smooth rounded shapes, realistic soft shadows, premium futuristic feel. Consistent Pixar-like 3D render quality. No text." /></div>;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t14) {
    t16 = <section className="relative px-4 py-10 sm:px-6 sm:py-16"><div className="mx-auto max-w-5xl"><div className="relative overflow-hidden rounded-2xl bg-linear-to-br from-slate-900 to-slate-800 px-6 py-10 sm:rounded-3xl sm:px-16 sm:py-16">{t0}<div className="relative z-10 grid items-center gap-10 lg:grid-cols-2">{t14}{t15}</div></div></div></section>;
    $[32] = t14;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  return t16;
}